export default class MultiDocumentHandler {
  constructor(webViewerUI, annotationService) {
    this.webViewerUI = webViewerUI
    this.tabManager = webViewerUI.TabManager
    this.annotationService = annotationService
    this.targetFromPrevTab = {}

    this.start = this.start.bind(this)
    this.onTheCurrentTab = this.onTheCurrentTab.bind(this)
    this.getActiveTab = this.getActiveTab.bind(this)
    this.setActiveTab = this.setActiveTab.bind(this)
    this.findTab = this.findTab.bind(this)
    this.cleanUpAnnotations = this.cleanUpAnnotations.bind(this)
    this.switchTabTo = this.switchTabTo.bind(this)
  }

  switchTabTo(filename, pageNumber, targetCoordinates) {
    const currentTab = this.tabManager.getActiveTab()

    if (filename !== decodeURIComponent(currentTab.options.filename)) {
      const newTab = this.findTab(filename)
      this.tabManager.setActiveTab(newTab.id)
      this.targetFromPrevTab[pageNumber] = targetCoordinates
      return true
    }

    return false
  }

  start() {
    this.webViewerUI.addEventListener(
      this.webViewerUI.Events.BEFORE_TAB_CHANGED,
      this.cleanUpAnnotations
    )
  }

  teardown() {
    this.webViewerUI.removeEventListener(
      this.webViewerUI.Events.BEFORE_TAB_CHANGED,
      this.cleanUpAnnotations
    )
  }

  cleanUpAnnotations() {
    this.annotationService.enableRedaction()
    this.annotationService.deleteAnnotations()
  }

  onTheCurrentTab(filename) {
    return (
      decodeURIComponent(this.tabManager.getActiveTab().options.filename) ===
      filename
    )
  }

  getActiveTab() {
    return this.tabManager.getActiveTab()
  }

  setActiveTab(id) {
    return this.tabManager.setActiveTab(id)
  }

  findTab(filename) {
    return this.tabManager
      .getAllTabs()
      .find((tab) => decodeURIComponent(tab.options.filename) === filename)
  }
}
